import React, { Component, Fragment } from 'react';
import { translate } from 'react-i18next';
import { landscape } from 'react-icons-kit/entypo/landscape';
import { ic_mode_edit } from 'react-icons-kit/md/ic_mode_edit';
import { ic_file_upload } from 'react-icons-kit/md/ic_file_upload';
import { trash } from 'react-icons-kit/fa/trash';
import { chevronUp } from 'react-icons-kit/fa/chevronUp';
import { chevronDown } from 'react-icons-kit/fa/chevronDown';
import { Icon } from 'react-icons-kit';

import Button from 'components/Button/Button';
import Warning from 'components/Warning/Warning';
import CustomModal from 'components/CustomModal/CustomModal';
import MTNSelector from 'components/MTNSelector/MTNSelector';
import ActionButton from 'components/ActionButton/ActionButton';
import Utils from 'utils/Utils';
import {
  getScale, addGeoJSONLayer, drawPolygon, clearDrawLayer, getBbox, openInfoDialog, getUploadedLayer,
  removeUploadedLayers, getDrawnFeatures, removeDrawInteraction, getFeaturesIntersectingExtent,
  addLayerFile, getFeaturesIntersectingGeometry, newGeoJSONLayer,
} from 'utils/Visor';

import MTN25 from 'static/mtn/mtn25-aragon.geojson';
import MTN50 from 'static/mtn/mtn50-aragon.geojson';
// import MTNIcon from 'static/img/mtnIcon.svg';
// import MTNIconSelected from 'static/img/mtnIconSelected.svg';

import './Actions.css';

declare var CONFIGURATIONS;

class Actions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: undefined,
      open: false,
      modalOption: undefined,
      mtnSelected: 'MTN50',
      mtnValue: '',
      mtnQuarter: 1,
      mtnLayer: undefined,
      selectedFeatures: this.props.selectedFeatures,
      selectedFullFeatures: this.props.selectedFullFeatures,
      centersLayer: this.props.centersLayer,
      hidden: true,
      flights: this.props.flights,
      asigned: false,
    };
  }

  componentDidMount() {
    if (document.getElementById('fileUploader') !== null) {
      document.getElementById('fileUploader').onchange = this.uploadFile;
      this.setState({ asigned: true });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props !== nextProps) {
      this.setState({
        selectedFeatures: nextProps.selectedFeatures,
        selectedFullFeatures: nextProps.selectedFullFeatures,
        centersLayer: nextProps.centersLayer,
        flights: nextProps.flights,
      });
    }
  }

  selectOption = (option) => {
    const _this = this;
    if (_this.state.centersLayer !== undefined) {
      if (_this.state.selected === option) {
        removeDrawInteraction();
        if (option === 'mtn') {
          removeUploadedLayers();
        }

        _this.setState({ selected: undefined });
      } else {
        if (option === 'upload') {
          document.getElementById('fileUploader').click();
        } else if (option === 'mtn') {
          this.setState({ selected: option, modalOption: option }, this.onOpenModal);
        } else if (option === 'edit') {
          if (getScale() <= CONFIGURATIONS.tools_min_scale) {
            this.setState({ selected: option }, () => {
              drawPolygon(_this.loadFotograms);
            });
          } else {
            this.setState({ modalOption: 'big-scale' }, this.onOpenModal);
          }
        } else if (option === 'select') {
          if (getScale() <= CONFIGURATIONS.tools_min_scale) {
            if (_this.state.centersLayer !== undefined) {
              let selectedFeatures = this.state.selectedFeatures;
              let selectedFullFeatures = this.state.selectedFullFeatures;
              const inside = getFeaturesIntersectingExtent(_this.state.centersLayer.source.features, getBbox());
              inside.forEach((i) => {
                if (selectedFeatures.indexOf(i.properties[CONFIGURATIONS.fotogram_attr]) === -1) {
                  selectedFeatures.push(i.properties[CONFIGURATIONS.fotogram_attr]);
                  selectedFullFeatures.push(i);
                }
              });

              this.setState({ selectedFeatures: selectedFeatures, selectedFullFeatures: selectedFullFeatures }, () => {
                _this.props.selectFeatures(selectedFeatures, selectedFullFeatures);
              });
            } else {
              let selectedFeatures = this.state.selectedFeatures || [];
              let selectedFullFeatures = this.state.selectedFullFeatures || [];
              this.props.block();
              for (let item = 0; item < _this.state.flights.length; item++) {
                const flight = _this.state.flights[item];
                const marksFile = flight.resources.filter((r) => r.format.toLowerCase() === 'geojson' && r.name.indexOf('huella_fotogramas') > -1)[0].url;
                Utils.getFile(marksFile).then((geojson) => {
                  const marks = newGeoJSONLayer({ source: geojson, name: CONFIGURATIONS.marks_name }, { displayInLayerSwitcher: false });
                  const inside = getFeaturesIntersectingExtent(marks.source.features, getBbox());
                  inside.forEach((i) => {
                    if (selectedFeatures.indexOf(i.properties[CONFIGURATIONS.fotogram_attr]) === -1) {
                      selectedFeatures.push(i.properties[CONFIGURATIONS.fotogram_attr]);
                      selectedFullFeatures.push(i);
                    }
                  });

                  if (item === _this.state.flights.length - 1) {
                    setTimeout(() => {
                      _this.setState({ selectedFeatures: selectedFeatures, selectedFullFeatures: selectedFullFeatures, selected: undefined }, () => {
                        _this.props.unblock();
                        _this.props.selectFeatures(selectedFeatures, selectedFullFeatures);
                      });
                    }, 1500);
                  }
                });
              }
            }
          } else {
            this.setState({ modalOption: 'big-scale' }, this.onOpenModal);
          }
        }
      }
    } else {
      this.setState({ modalOption: 'unavailable' }, this.onOpenModal);
    }
  }

  uploadFile = (evt) => {
    const { t } = this.props;
    const file = document.getElementById('fileUploader').files[0];
    const fileName = file !== undefined ? file.name.split('.').pop() : '';
    if (file !== undefined && file.size > CONFIGURATIONS.max_file_size) {
      const text = t('actions.max_size_file').replace('*', (CONFIGURATIONS.max_file_size / Math.pow(1024, 2)));
      openInfoDialog(text);
    } else if (file !== undefined && CONFIGURATIONS.upload_extensions.indexOf(fileName) > -1) {
      addLayerFile(file, this.props.block, this.unblockUpload, t);
    } else if (file !== undefined) {
      openInfoDialog(t('actions.file_type'));
    }
  }

  unblockUpload = (unselect) => {
    this.props.unblock();
    if (unselect) {
      this.setState({ selected: undefined });
    } else {
      this.setState({ selected: 'upload' });
    }
  }

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false, selected: undefined, modalOption: undefined });
  };

  getSheet = (evt) => {
    this.setState({ mtnSelected: evt.target.value }, () => {
      document.getElementById('sheetMTN50').value = '';
      document.getElementById('sheetMTN25').value = '';
    });
  }

  getSheetValue = (evt) => {
    let value = evt.target.value;
    if (value.length < 4) {
      while (value.length < 4) {
        value = '0' + value;
      }
    }

    this.setState({ mtnValue: value });
  }

  getQuarter = () => {
    const quarter = document.getElementById('selectSheetQuarter').value;
    this.setState({ mtnQuarter: quarter });
  }

  showSheet = () => {
    const _this = this;
    const { mtnSelected, mtnQuarter, mtnValue } = this.state;
    let file = MTN50;
    let property = 'MTN50_CLAS';
    let value = mtnValue;
    if (mtnSelected === 'MTN25') {
      file = MTN25;
      property = 'MTN25_CLAS';
      value = mtnValue + '-' + mtnQuarter;
    }

    Utils.getFile(file).then((geojson) => {
      const features = [].concat(geojson.features);
      geojson.features = features.filter((item) => {
        return item.properties[property] === value;
      });

      if (geojson.features.length === 1) {
        removeUploadedLayers();
        const mtnLayer = addGeoJSONLayer({ source: geojson, name: 'Hoja ' + value }, {
          displayInLayerSwitcher: false,
        }, 'Polygon', true, CONFIGURATIONS.fotograms_zoom, CONFIGURATIONS.max_zoom, true);
        _this.setState({ open: false, modalOption: undefined, mtnLayer: mtnLayer });
      } else {
        _this.setState({ modalOption: 'not-found-mtn' }, _this.onOpenModal);
      }
    });
  }

  loadFotograms = () => {
    const _this = this;
    this.props.block();
    setTimeout(() => {
      let selectedFeatures = this.state.selectedFeatures;
      let selectedFullFeatures = this.state.selectedFullFeatures;
      if (_this.state.selected === 'edit') {
        const drawnFeatures = getDrawnFeatures();
        drawnFeatures.forEach((f) => {
          const inside = getFeaturesIntersectingGeometry(_this.state.centersLayer.source.features, f);
          inside.forEach((i) => {
            if (selectedFeatures.indexOf(i.properties[CONFIGURATIONS.fotogram_attr]) === -1) {
              selectedFeatures.push(i.properties[CONFIGURATIONS.fotogram_attr]);
              selectedFullFeatures.push(i);
            }
          });
        });

        _this.setState({ selectedFeatures: selectedFeatures, selectedFullFeatures: selectedFullFeatures, selected: undefined }, () => {
          clearDrawLayer();
          _this.props.unblock();
          _this.props.selectFeatures(selectedFeatures, selectedFullFeatures);
        });
      } else if (_this.state.selected === 'mtn') {
        const mtnLayer = _this.state.mtnLayer;
        const extent = mtnLayer.getImpl().getOL3Layer().getSource().getFeatures()[0].getGeometry().getExtent();
        const inside = getFeaturesIntersectingExtent(_this.state.centersLayer.source.features, extent);
        inside.forEach((i) => {
          if (selectedFeatures.indexOf(i.properties[CONFIGURATIONS.fotogram_attr]) === -1) {
            selectedFeatures.push(i.properties[CONFIGURATIONS.fotogram_attr]);
            selectedFullFeatures.push(i);
          }
        });

        _this.setState({ selectedFeatures: selectedFeatures, selectedFullFeatures: selectedFullFeatures, selected: undefined }, () => {
          _this.props.unblock();
          _this.props.selectFeatures(selectedFeatures, selectedFullFeatures);
        });
      } else if (_this.state.selected === 'upload') {
        const uploadedLayer = getUploadedLayer();
        uploadedLayer.getImpl().getOL3Layer().getSource().getFeatures().forEach((f) => {
          const inside = getFeaturesIntersectingGeometry(_this.state.centersLayer.source.features, f);
          inside.forEach((i) => {
            if (!Utils.arrayContainsString(selectedFeatures, i.properties[CONFIGURATIONS.fotogram_attr])) {
              selectedFeatures.push(i.properties[CONFIGURATIONS.fotogram_attr]);
              selectedFullFeatures.push(i);
            }
          });
        });

        _this.setState({ selectedFeatures: selectedFeatures, selectedFullFeatures: selectedFullFeatures, selected: undefined }, () => {
          _this.props.unblock();
          _this.props.selectFeatures(selectedFeatures, selectedFullFeatures);
        });
      } else {
        this.props.unblock();
      }
    }, 1000);
  }

  clear = () => {
    clearDrawLayer();
    removeUploadedLayers();
    if (this.state.selected === 'mtn' || this.state.selected === 'edit') {
      this.setState({ selected: undefined });
    }
  }

  toogleHidden = () => {
    const inv = !this.state.hidden;
    this.setState({ hidden: inv }, () => {
      const elem = document.querySelector('nav:nth-child(1) > div.listContainer > div.table.row > div');
      if (inv && elem !== null) {
        elem.style.minHeight = '200px';
        elem.style.maxHeight = 'calc(100vh - 590px)';
      } else if (elem !== null) {
        elem.style.minHeight = '100px';
        elem.style.maxHeight = 'calc(100vh - 640px)';
      }

      if (inv === false && this.state.asigned !== true && document.getElementById('fileUploader') !== null) {
        document.getElementById('fileUploader').onchange = this.uploadFile;
        this.setState({ asigned: true });
      }
    });
  }

  render() {
    const { t } = this.props;
    const { selected, open, mtnQuarter, mtnSelected, modalOption, hidden, flights } = this.state;
    let titleModal = t('actions.warning');
    if (modalOption === 'mtn') {
      titleModal = t('actions.search_fotograms');
    }

    const tooltipFile = <div>
      <p>{t('actions.using_geometry')}</p>
      <p style={{ textAlign: 'left', fontSize: '12px' }}><i>*{t('actions.allowed_formats')}<br /><br />*{t('actions.srs')}</i></p>
    </div>;

    return (
      <Fragment>
        <div className='actionsContainer'>
          <div className='actionsTitleContainer row'>
            <div className='collapse-icon-title'>{t('actions.tools')}</div>
            <div className='collapse-icon-frames' onClick={this.toogleHidden}><Icon size={'1.2rem'} icon={hidden ? chevronDown : chevronUp} /></div>
          </div>
          {!hidden ?
            <div>
              <div className='buttonsContainer row'>
                <ActionButton id='selectExtent' icon={landscape} size={'20px'} rounded={true} tooltip={t('actions.view_extend')}
                  selected={selected === 'select'} onClick={this.selectOption.bind(null, 'select')} disabled={flights.length === 0} />
                <ActionButton id='drawPolygon' icon={ic_mode_edit} size={'24px'} rounded={true} tooltip={t('actions.polygons')}
                  selected={selected === 'edit'} onClick={this.selectOption.bind(null, 'edit')} disabled={flights.length === 0} />
                {/*
                  <ActionButton id='selectMTN' icon={selected === 'mtn' ? MTNIconSelected : MTNIcon} size={'24px'} rounded={true}
                    onClick={this.selectOption.bind(null, 'mtn')} selected={selected === 'mtn'} disabled={flights.length === 0}
                    notInside={true} imageStyle={{ width: '24px', marginLeft: '2px' }} tooltip={t('actions.mtn_sheet')} />
                  */}
                <ActionButton id='selectFile' icon={ic_file_upload} size={'24px'} rounded={true} tooltip={tooltipFile}
                  selected={selected === 'upload'} onClick={this.selectOption.bind(null, 'upload')} />
                <input type='file' id='fileUploader' name='fileUploader' style={{ display: 'none' }} />
                <ActionButton id='clearFigures' icon={trash} size={'24px'} rounded={true} tooltip={t('actions.remove_criteria')}
                  selected={false} onClick={this.clear} disabled={flights.length === 0} />
              </div>
              {(selected === 'upload' || selected === 'mtn') ?
                <div className='buttonsContainer row'>
                  <Button text={t('actions.load_selection')} active={true} onClick={this.loadFotograms} />
                </div>
                : null}
              <CustomModal open={open} onClose={this.onCloseModal} title={titleModal}>
                {modalOption === 'mtn' ?
                  <MTNSelector getSheet={this.getSheet} getSheetValue={this.getSheetValue}
                    getQuarter={this.getQuarter} mtnSelected={mtnSelected} mtnQuarter={mtnQuarter}
                    showSheet={this.showSheet} />
                  : modalOption === 'big-scale' ?
                    <Warning>
                      <p>{t('actions.available_scale_1') + ' '} <b>1/{CONFIGURATIONS.tools_min_scale}</b> {' ' + t('actions.available_scale_2')}</p>
                    </Warning>
                    : modalOption === 'not-found-mtn' ?
                      <Warning>
                        <p>{t('actions.sheet_not_found')}</p>
                      </Warning>
                      : modalOption === 'unavailable' ?
                        <Warning>
                          <p>{t('actions.select_flight')}</p>
                        </Warning>
                        : null}
              </CustomModal>
            </div>
            : null}
        </div>
      </Fragment>
    );
  }
}

export default translate()(Actions);
